<template>
  <div class='top'>
    <header-normal />
    <service-end-notice />
    <section-fv />
    <section-experience />
    <section-reason />
    <section-media />
    <section-plan />
    <section-course />
    <section-comparison />
    <section-close />
    <section-faq />
    <footer-normal />
  </div>
</template>

<script>
import HeaderNormal from '@/components/lps/top/HeaderNormal.vue';
import SectionFv from '@/components/lps/top/SectionFv.vue';
import SectionExperience from '@/components/lps/top/SectionExperience.vue';
import SectionReason from '@/components/lps/top/SectionReason.vue';
import SectionMedia from '@/components/lps/top/SectionMedia.vue';
import SectionCourse from '@/components/lps/top/SectionCourse.vue';
import SectionPlan from '@/components/lps/top/SectionPlan.vue';
import SectionComparison from '@/components/lps/top/SectionComparison.vue';
import SectionClose from '@/components/lps/top/SectionClose.vue';
import SectionFaq from '@/components/lps/top/SectionFaq.vue';
import FooterNormal from '@/components/lps/top/FooterNormal.vue';
import ServiceEndNotice from '@/components/atoms/other/ServiceEndNotice.vue';

export default {
  components: {
    HeaderNormal,
    SectionFv,
    SectionExperience,
    SectionReason,
    SectionMedia,
    SectionCourse,
    SectionPlan,
    SectionComparison,
    SectionClose,
    SectionFaq,
    FooterNormal,
    ServiceEndNotice,
  },
  methods: {
    setImageUrl(path) {
      return `${process.env.VUE_APP_S3_MATERIAL_URL}/${path}`;
    },
  },
};
</script>

<style lang="scss">
.top {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
}

/* コンテンツ幅 */
.pc-width {
  max-width: 800px;
}
.cv__button {
  display: flex;
  justify-content: center;
  margin-bottom: 80px;
}

@media screen and (max-width: 650px) {
.cv__button {
  margin-bottom: 40px;
}
}
</style>
